module.exports = __webpack_public_path__ + "static/img/dzb_loginbg.7e69bcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dzb_loginbg.jpg
// module id = V0Mw
// module chunks = 194